// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PJGI","buttons":"styles_buttons__3zVnY"};